import { createColumnHelper } from '@tanstack/react-table';
import { ADJUSTMENT_COPY, ROUNDING_COPY } from 'src/components/PriceSchemeChannelRulesTab/constants';
import { capitalise } from 'src/helpers/capitalise';
import { formatPriceValue } from 'src/helpers/formatPrice/formatPrice';
import { AdjustmentType, IPriceRule, RoundingType } from 'src/types/price.types';

type SharedColumnCopy = {
  noneAdjustment?: string;
  noneRounding?: string;
};

export const sharedTableColumns = <T extends IPriceRule>(copy?: SharedColumnCopy) => {
  const columnHelper = createColumnHelper<T>();
  const noneAdjustmentText = copy?.noneAdjustment ?? ADJUSTMENT_COPY.NONE;
  const noneRoundingText = copy?.noneRounding ?? ROUNDING_COPY.NONE;

  return [
    columnHelper.accessor(({ adjustment }) => adjustment?.type, {
      header: 'Calculation Rule',
      cell: (props) => {
        const type = props.getValue();

        if (!type || type === AdjustmentType.NONE) {
          return noneAdjustmentText;
        }

        return ADJUSTMENT_COPY[type];
      },
    }),
    columnHelper.accessor(({ adjustment }) => adjustment, {
      id: 'adjustment.value',
      header: 'Calculation Value',
      cell: (props) => {
        const adjustment = props.getValue();
        if (!adjustment?.value) {
          return '-';
        }

        const value = formatPriceValue(adjustment.value);
        return adjustment.type === AdjustmentType.PERCENTAGE ? `${value}%` : value;
      },
    }),
    columnHelper.accessor(({ rounding }) => rounding, {
      header: 'Rounding',
      size: 200,
      cell: (props) => {
        const rounding = props.getValue();
        if (!rounding || !rounding?.method || rounding?.type === RoundingType.NONE) {
          return noneRoundingText;
        }

        return `${ROUNDING_COPY[rounding.type]} (${capitalise(rounding.method)})`;
      },
    }),
    columnHelper.accessor(({ rounding }) => rounding?.value, {
      header: 'Rounding Value',
      cell: (props) => {
        const value = props.getValue();
        return value ? formatPriceValue(value) : '-';
      },
    }),
  ];
};
